import { createContext, useContext } from 'react';

import { MedicalProfileTabFormController, MedicalProfileTabViewModel } from './tab/MedicalProfileTab.types';

export type MedicalProfileFormContextValue = Pick<MedicalProfileTabFormController, 'register' | 'control'> & {
   readonly readonly: boolean;
   readonly registerViewModel: (viewModel: MedicalProfileTabViewModel) => void;
};

export const MedicalProfileFormContext = createContext<MedicalProfileFormContextValue | null>(null);

export const useMedicalProfileFormContext = (): MedicalProfileFormContextValue => {
   const context = useContext(MedicalProfileFormContext);
   if (context === null) {
      throw new Error('useMedicalProfileFormContext must be used within MedicalProfileFormContext.Provider!');
   }
   return context;
};
